import { createTheme } from '@material-ui/core/styles';

const primarycolor = '#f5f5f5';
const secondarycolor = '#969696';
export default createTheme({
  palette: {
    type: 'dark',
    primary: { main: secondarycolor },
    secondary: { main: primarycolor },
    background: {
      paper: '#fff',
    },
  },
  status: {
    danger: 'orange',
  },
});
